import { render, staticRenderFns } from "./OpportunityFormStep2.vue?vue&type=template&id=45b520c3"
import script from "./OpportunityFormStep2.vue?vue&type=script&lang=js"
export * from "./OpportunityFormStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b520c3')) {
      api.createRecord('45b520c3', component.options)
    } else {
      api.reload('45b520c3', component.options)
    }
    module.hot.accept("./OpportunityFormStep2.vue?vue&type=template&id=45b520c3", function () {
      api.rerender('45b520c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Opportunity/Form/OpportunityFormStep2.vue"
export default component.exports